module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/store/storelist/storelist.component.css
// module id = ./src/app/mywallet/store/storelist/storelist.component.css
// module chunks = main